import { authStore } from "@/store/auth"

import { useBillingStore } from "../store/billing-store"

export interface Entitlement {
  isPartner: boolean
  isExpired: boolean
  needsPlan: boolean
  treatAsSubscriber: boolean
  isActive: boolean
}

/**
 * Ponto único de acesso ao "direito de uso" da conta, já considerando parceiro.
 * Organizações parceiras são tratadas como usuário ativo: nunca expiram, não veem
 * CTA de plano e ganham a UI de assinante. Os campos crus de assinatura continuam
 * no billing-store para telas que precisam da verdade de assinatura.
 */
export function useEntitlement(): Entitlement {
  const isPartner = authStore(state => state.user?.is_partner === true)
  const { isSubscriber, isSubscriptionActive, isSubscriptionExpired } = useBillingStore()

  return {
    isPartner,
    isExpired: !isPartner && isSubscriptionExpired === true,
    needsPlan: !isPartner && isSubscriber === false,
    treatAsSubscriber: isPartner || isSubscriber === true,
    isActive: isPartner || isSubscriptionActive === true,
  }
}
